package com.tedd.db

import kotlin.Long
import kotlin.String

public data class ProjectStatus(
  public val id: String,
  public val project_id: String,
  public val name: String,
  public val color: String,
  public val order_index: Long,
  public val is_terminal: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
